import React from "react";

import ToolUsageCard from "./ToolUsageCard";
import TokensCard from "./TokensCard";
import FeatureTable from "./FeatureTable";

/**
 * The three-layer usage report, shared by the tenant-admin page, the SuperAdmin
 * usage page and the SuperAdmin per-tenant tab.
 *
 * Reads top-down from business meaning to cost:
 *
 *     Candidate Matching             used 40 times     ← tool count
 *       ├─ Intake                        28            ← sub-dimension
 *       └─ Retrigger                     12
 *     Interview Questions            used 18 times
 *       ├─ Domain Specific                6
 *       └─ Experience Based               8
 *
 *     LLM calls      412   (37 served from cache)
 *     Total tokens   1,550,000
 *
 * Each card is a file of its own — `ToolUsageCard`, `TokensCard`,
 * `FeatureTable` — and this composes them in that order. The SuperAdmin usage
 * page imports the three directly instead, because it puts its own headline band
 * and its own tenant context between them; building that from the same three
 * pieces is what keeps the two screens one report rather than two that resemble
 * each other.
 */
const UsageSummary = ({ summary, title = "Tool usage", emptyHint }) => {
  // Both are present only when the caller asked for engineering detail. Both
  // are absent from a tenant response entirely — presence, never a role test.
  const callDetail = summary?.llmCallDetail ?? null;
  const features = summary?.features ?? [];

  return (
    <div className="flex flex-col gap-4">
      <ToolUsageCard modules={summary?.modules ?? []} title={title} emptyHint={emptyHint} />
      <TokensCard tokens={summary?.tokens ?? {}} callDetail={callDetail} features={features} />
      <FeatureTable features={features} />
    </div>
  );
};

export default UsageSummary;
